import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, ShieldCheck } from 'lucide-react';
export function Contact() {
  return <section className="py-24 bg-white" data-id="element-347">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-348">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-349">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} data-id="element-350">
            <h1 className="text-4xl md:text-5xl font-black text-federal-blue mb-8" data-id="element-351">
              Contact Our <br data-id="element-352" />
              <span className="text-tech-slate" data-id="element-353">Federal Solutions Team</span>
            </h1>
            <p className="text-lg text-tech-slate mb-12 opacity-80 leading-relaxed" data-id="element-354">
              Ready to secure your agency's mission? Our team is available for
              rapid response consultations across the Mid-Atlantic and Southeast
              regions.
            </p>

            <div className="space-y-8" data-id="element-355">
              <div className="flex items-start gap-4" data-id="element-356">
                <div className="w-12 h-12 bg-federal-blue/5 flex items-center justify-center rounded-sm" data-id="element-357">
                  <Mail className="w-6 h-6 text-federal-blue" data-id="element-358" />
                </div>
                <div data-id="element-359">
                  <h4 className="font-bold text-federal-blue uppercase text-xs tracking-widest mb-1" data-id="element-360">
                    Email
                  </h4>
                  <p className="text-tech-slate font-medium" data-id="element-361">
                    gov@codesandcogs.com
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-362">
                <div className="w-12 h-12 bg-federal-blue/5 flex items-center justify-center rounded-sm" data-id="element-363">
                  <Phone className="w-6 h-6 text-federal-blue" data-id="element-364" />
                </div>
                <div data-id="element-365">
                  <h4 className="font-bold text-federal-blue uppercase text-xs tracking-widest mb-1" data-id="element-366">
                    Phone
                  </h4>
                  <p className="text-tech-slate font-medium" data-id="element-367">
                    +1 (800) COGS-GOV
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-368">
                <div className="w-12 h-12 bg-federal-blue/5 flex items-center justify-center rounded-sm" data-id="element-369">
                  <MapPin className="w-6 h-6 text-federal-blue" data-id="element-370" />
                </div>
                <div data-id="element-371">
                  <h4 className="font-bold text-federal-blue uppercase text-xs tracking-widest mb-1" data-id="element-372">
                    Headquarters
                  </h4>
                  <p className="text-tech-slate font-medium" data-id="element-373">
                    Charlotte, NC | Baltimore, MD
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} className="bg-slate-50 p-8 md:p-12 border border-slate-200 shadow-sm" data-id="element-374">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-375">
              <div className="grid md:grid-cols-2 gap-6" data-id="element-376">
                <div className="space-y-2" data-id="element-377">
                  <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-378">
                    Full Name
                  </label>
                  <input type="text" className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="John Doe" data-id="element-379" />
                </div>
                <div className="space-y-2" data-id="element-380">
                  <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-381">
                    Agency / Organization
                  </label>
                  <input type="text" className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="e.g. GSA" data-id="element-382" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-383">
                <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-384">
                  Work Email (.gov / .mil preferred)
                </label>
                <input type="email" className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="j.doe@agency.gov" data-id="element-385" />
              </div>
              <div className="space-y-2" data-id="element-386">
                <label className="text-[10px] font-black uppercase tracking-widest text-tech-slate" data-id="element-387">
                  Message
                </label>
                <textarea rows={4} className="w-full px-4 py-3 bg-white border border-slate-200 focus:ring-2 focus:ring-federal-blue outline-none transition-all" placeholder="How can we support your mission?" data-id="element-388"></textarea>
              </div>
              <button className="w-full bg-federal-blue hover:bg-federal-blue/90 text-white py-4 font-bold flex items-center justify-center gap-2 transition-all shadow-lg" data-id="element-389">
                <Send className="w-4 h-4" data-id="element-390" />
                Submit Secure Inquiry
              </button>
              <p className="text-[10px] text-center text-tech-slate opacity-60 flex items-center justify-center gap-1.5 uppercase font-bold tracking-tighter" data-id="element-391">
                <ShieldCheck className="w-3 h-3" data-id="element-392" />
                Encrypted & NIST 800-171 Compliant Submission
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}